import DetailsTab from './details-tab';

export default DetailsTab;
